import React from 'react';
import { Divider, List, ListItemButton, ListItemText } from '@mui/material';
import { colorPalette, colorTokens } from '@rideiq/shared/components/variables';

import { SECTION_KEYS, SECTION_LABELS, SectionKey } from '../types';

type SectionGutterProps = {
  activeSection: SectionKey;
  onScrollTo: (section: SectionKey) => void;
};

export const SectionGutter = ({ activeSection, onScrollTo }: SectionGutterProps) => (
  <List
    component="nav"
    aria-label="Rider form sections"
    disablePadding
    data-testid="section-gutter"
    sx={{
      width: 300,
      flexShrink: 0,
      bgcolor: colorPalette.neutral99,
      border: `1px solid ${colorPalette.neutralVariant90}`,
      borderRadius: '12px',
      overflow: 'hidden',
    }}
  >
    {SECTION_KEYS.map((key, index) => (
      <React.Fragment key={key}>
        <ListItemButton
          selected={activeSection === key}
          onClick={() => onScrollTo(key)}
          data-testid={`gutter-item-${key}`}
          sx={{
            py: '20px',
            px: '24px',
            borderRadius: 0,
            '&.Mui-selected': { bgcolor: 'transparent' },
            '&.Mui-selected .MuiListItemText-primary': { color: colorTokens.primary.main, fontWeight: 500 },
          }}
        >
          <ListItemText primary={SECTION_LABELS[key]} />
        </ListItemButton>
        {index < SECTION_KEYS.length - 1 && <Divider sx={{ borderColor: colorPalette.neutralVariant90 }} />}
      </React.Fragment>
    ))}
  </List>
);
